import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import FollowingWatchIcon from '@wix/da-ds/pkg/Icons/16x16/FollowingWatch';
const PremiumFolderDataIcon = (_param)=>{
    var { premiumFolderData } = _param, iconProps = _object_without_properties(_param, [
        "premiumFolderData"
    ]);
    var _premiumFolderData;
    switch((_premiumFolderData = premiumFolderData) === null || _premiumFolderData === void 0 ? void 0 : _premiumFolderData.type){
        case 'paid':
            return /*#__PURE__*/ React.createElement(PremiumGallery, iconProps);
        case 'watchers':
            return /*#__PURE__*/ React.createElement(FollowingWatchIcon, iconProps);
        default:
            return null;
    }
};
PremiumFolderDataIcon.displayName = 'PremiumFolderDataIcon';
export default PremiumFolderDataIcon;
